/**
 * InteractionTypeCell - Displays interaction type with appropriate icon and tooltip
 *
 * Specialized cell component for displaying interaction types in table/grid views.
 */

import { ButtonTooltip } from '@evertrue/et-components';
import { isEmpty } from '@evertrue/sdk';
import PropTypes from 'prop-types';
import InteractionIcon from '../interaction-icon';

/**
 * Displays interaction type with appropriate icon and tooltip
 * @param {Object} interaction - Interaction object with type and target information
 */
const InteractionTypeCell = ({ interaction = {} }) => {
  if (isEmpty(interaction)) {
    return null;
  }

  const { target_id, contact_id } = interaction;
  const isSecondaryInteraction = target_id !== contact_id;

  return (
    interaction && (
      <ButtonTooltip trigger={<InteractionIcon isSecondary={isSecondaryInteraction} interaction={interaction} />}>
        {interaction.interaction_type}
      </ButtonTooltip>
    )
  );
};

InteractionTypeCell.propTypes = {
  interaction: PropTypes.object,
};

export default InteractionTypeCell;
